import { render, staticRenderFns } from "./sinp.vue?vue&type=template&id=6c5898dd&"
import script from "./sinp.vue?vue&type=script&lang=js&"
export * from "./sinp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports